import { setDefaultOptions, isSameDay, format } from "date-fns";
import { da } from "date-fns/locale";

export default function () {
    setDefaultOptions({
        locale: da,
    });
    window.dateFns = {
        isSameDay,
        format,
    };
}